import React from 'react'
import { Row, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './ParcelSelectFields.module.scss'
import { setMassiveCalculationParcelKeys } from 'src/features'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomSelect, CustomTitle, CustomCol } from 'src/components'
const { Option } = Select

const ParcelSelectFields = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { fileKeys, parcelKeys } = useAppSelector((state) => state.admin.massiveCalculation)

  return (
    <>
      <Row>
        <CustomCol className='select-padding'>
          <CustomTitle label={t('admin.MassiveCalculate.FromField')} className={styles['title-position']} />
          <CustomSelect
            placeholder={t('admin.MassiveCalculate.FromField')}
            value={parcelKeys.from}
            onChange={(value: string) => dispatch(setMassiveCalculationParcelKeys({ ...parcelKeys, from: value }))}
          >
            {fileKeys.map((item, idx) => <Option key={idx} value={item}>{item}</Option>)}
          </CustomSelect>
        </CustomCol>
        <CustomCol className='select-padding'>
          <CustomTitle label={t('admin.MassiveCalculate.ToField')} className={styles['title-position']} />
          <CustomSelect
            placeholder={t('admin.MassiveCalculate.ToField')}
            value={parcelKeys.to}
            onChange={(value: string) => dispatch(setMassiveCalculationParcelKeys({ ...parcelKeys, to: value }))}
          >
            {fileKeys.map((item, idx) => <Option key={idx} value={item}>{item}</Option>)}
          </CustomSelect>
        </CustomCol>
      </Row>

      <Row>
        <CustomCol className='select-padding'>
          <CustomTitle label={t('admin.MassiveCalculate.WeigthField')} className={styles['title-position']} />
          <CustomSelect
            placeholder={t('admin.MassiveCalculate.WeigthField')}
            value={parcelKeys.weigth}
            onChange={(value: string) => dispatch(setMassiveCalculationParcelKeys({ ...parcelKeys, weigth: value }))}
          >
            {fileKeys.map((item, idx) => <Option key={idx} value={item}>{item}</Option>)}
          </CustomSelect>
        </CustomCol>
        <CustomCol className='select-padding'>
          <CustomTitle label={t('admin.MassiveCalculate.FleetTypeField')} className={styles['title-position']} />
          <CustomSelect
            placeholder={t('admin.MassiveCalculate.FleetTypeField')}
            value={parcelKeys.fleetType}
            onChange={(value: string) => dispatch(setMassiveCalculationParcelKeys({ ...parcelKeys, fleetType: value }))}
          >
            {fileKeys.map((item, idx) => <Option key={idx} value={item}>{item}</Option>)}
          </CustomSelect>
        </CustomCol>
      </Row>
    </>
  )
}

export default ParcelSelectFields
